export default {
  POLL_GETPOLL: '/api/vote/info',                                      // 获取投票题目

  POLL_VOTE: '/api/vote/poll',                                         // 投票

  POLL_LIST: '/api/vote/list',                                         // 投票列表

  PLAZA_POLL_LIST: '/api/banner/banners',                              // 活动广场banner

  CHECK_SIGN: '/api/check/sign',                                       // 签到

  CHECK_SIGNRECORD: '/api//check/signRecord',                          // 签到记录

  PLAZA_CONTENT_CLASS: '/api/activityContent/getContentClass',         // 查询专题（活动广场首页、内容列表）

  PLAZA_CONTENT_SAVE: '/api/activityContent/save',                     // 提交内容/保存草稿

  PLAZA_CONTENT_LIST: '/api/activityContent/getContentList',           // 2.查询内容列表（内容列表、达人专栏、我的内容列表）

  PLAZA_CONTENT_RECOMMEND: '/api/activityContent/getContentRecommend', // 4.内容推荐列表

  PLAZA_CONTENT_DELETE: '/api/activityContent/delete',                 // 6.删除内容/草稿

  PLAZA_SQUARE_USERINFO: '/api/check/squareUserInfo',                  // 7.用户信息

  PLAZA_MY_CONTENTLIST: '/api/activityContent/getMyContentList',       // 7.3.我的内容列表

  PLAZA_MY_USERINFO: '/api/activityContent/getUserInfo',               // 7.3.我的内容列表

  PLAZA_GET_CONTENT: '/api/activityContent/getContent',                // 查询内容详情

  PLAZA_CONTENT_RANKING: '/api/activityContent/getContentRanking',     // 5.分享达人

  PLAZA_POST_RANKING: '/api/activityContent/getPostRanking',           // 话题贡献排行榜

  PLAZA_GET_RECOMMEND: '/api/activityContent/getContentRecommend',     // 6.内容推荐列表

  PLAZA_GET_DRAFT: '/api/activityContent/getDraft',                    // 获取草稿

  PLAZA_CUR_LIST: '/api/common/task/curlist',                          // 活动广场获取任务列表

  PLAZA_POSTS_INFO: '/api/posts/info',                                 // 活动广场话题详情

  PLAZA_HOT_TAGS: '/api/common/topTags',                               // 活动广场获取热门话题

  PLAZA_FANS_LIST: '/api/follow/fansList',                             // 活动广场粉丝列表

  PLAZA_FOLLOW_LIST: '/api/follow/followerList',                       // 活动广场关注列表

  PLAZA_FOLLOW_ADD: '/api/follow/add',                                 // 添加关注

  PLAZA_FOLLOW_CANCEL: '/api/follow/cancel',                           // 取消关注

  PLAZA_COMMON_ACTIVITIES: '/api/common/contest/activities',           // 所有活动广场

  PLAZA_ACTIVITY_LIST: '/api/activityContent/getActivityList',         // 首页集合

  V2_ENTERING_LIST: '/api/v3/contest/contest/entering/list',                   // 搜索页面最近报名的活动

  SEARCH_CONTENT: '/api/search/content',                               // 内容搜索

  // SEARCH_CONTEST: '/api/search/contest',                               // 活动搜索
  SEARCH_CONTEST: '/api/v3/contest/contest/user/search',                               // 活动搜索

  // SEARCH_CONTEST_INTEREST: '/api/search/contest/interest',             // 可能感兴趣的活动搜索
  SEARCH_CONTEST_INTEREST: '/api/v3/contest/contest/user/search/interest',             // 可能感兴趣的活动搜索

  SEARCH_ORGANIZATION: '/api/search/organization',                     // 组织搜索

  SEARCH_USER: '/api/search/user',                                     // 用户搜索

  SEARCH_ASSOCIATION: '/api/search/association'                        // 俱乐部搜索
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/event-plaza.js